import 'devextreme/dist/css/dx.common.css';
//import 'devextreme/dist/css/dx.light.css';
//import 'devextreme/dist/css/dx.greenmist.css';
import 'devextreme/dist/css/dx.greenmist.compact.css';
//import 'devextreme/dist/css/dx.softblue.css';
//import 'devextreme/dist/css/dx.carmine.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';


Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
